


















import { ciClock } from '~/icons/source/solid/clock'
import { computed, defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  props: {
    workingHours: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const workingHoursArray = computed(() => {
      return (
        props.workingHours &&
        props.workingHours.split('\n').map(w => w.replace('/', ''))
      )
    })
    return { ciClock, workingHoursArray }
  }
})
